import styled from 'styled-components';

import { Backdrop } from '@mui/material';

export const BackdropLoadingBase = styled(Backdrop)`
  z-index: 9999;
`;
